import React from 'react';
import { ChevronRight } from 'lucide-react';
import BetaLink from '../../beta/BetaLink';

const PageBanner = ({
  title,
  breadcrumbs = [],
  backgroundImage = '/images/hero/sweet-wallpaper.jpg'
}) => {
  return (
    <div
      className="relative bg-cover bg-center py-20"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">
          {title}
        </h1>

        {breadcrumbs.length > 0 && (
          <nav className="flex items-center justify-center gap-2 text-white/80 text-sm">
            <BetaLink to="/" className="hover:text-white transition-colors">
              Home
            </BetaLink>
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                <ChevronRight size={16} />
                {crumb.href ? (
                  <BetaLink to={crumb.href} className="hover:text-white transition-colors">
                    {crumb.label}
                  </BetaLink>
                ) : (
                  <span className="text-white">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
      </div>
    </div>
  );
};

export default PageBanner;
